export default {
    doVarification(searchValue, type, varificationCallback) {
        let URL = `https://bpi.briteverify.com/${type}s/verify.js?username=lendingtree`;
        URL += (type === 'phone' ? '&phone[number]=' : '&email[address]=') + searchValue;
        this.briteVerifyService(URL, (data) => {
            const getStatus = data[type].status === 'valid';
            varificationCallback(type, getStatus);
        });
    },
    briteVerifyService(url, callback) {
        const callbackName = 'showResponse';
        const script = document.createElement('script');
        window[callbackName] = (data) => {
            delete window[callbackName];
            document.body.removeChild(script);
            callback(data);
        };
        script.src = `${url + (url.indexOf('?') >= 0 ? '&' : '?')}callback=${callbackName}`;
        document.body.appendChild(script);
    },
};
